export default __webpack_public_path__ + "static/media/post2.748ad044.png";